/* SZPLIN INVEST V5: local only, no external tracking or dependencies */
(function(){
 function init(root){
  if(root.dataset.investReady==='true')return;
  root.dataset.investReady='true';
  var buttons=root.querySelectorAll('[data-invest-target]');
  function setSector(sector,updateUrl){
   if(sector!=='hotel')sector='developer';
   root.dataset.sector=sector;
   root.querySelectorAll('[data-invest-only]').forEach(function(el){el.hidden=(el.dataset.investOnly!==sector);});
   buttons.forEach(function(button){var active=button.dataset.investTarget===sector;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});
   var selector=root.querySelector('[data-invest-select]');
   if(selector && (selector.value==='Deweloper / osiedle'||selector.value==='Hotel / obiekt turystyczny'))selector.value=sector==='hotel'?'Hotel / obiekt turystyczny':'Deweloper / osiedle';
   if(updateUrl && (location.protocol==='https:'||location.protocol==='http:') && history.replaceState){var u=new URL(location.href);u.searchParams.set('sector',sector);history.replaceState(null,'',u.pathname+u.search+u.hash);}
  }
  buttons.forEach(function(button){button.addEventListener('click',function(){setSector(button.dataset.investTarget,true);});});
  var query=new URLSearchParams(location.search);
  setSector(query.get('sector')==='hotel'?'hotel':'developer',false);
 }
 function start(){document.querySelectorAll('[data-sz-invest]').forEach(init)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 document.addEventListener('shopify:section:load',start);
})();
